module.exports = __webpack_public_path__ + "static/media/voltmill-3.8d622c5f.jpg";